// SustainabilityFeatures.js
import React from 'react';
import '../styles/SustainabilityFeatures.css';

const SustainabilityFeatures = () => {
  return (
    <section className="sustainability-features">
      <h2>Sustainability Features</h2>
      <p>Eco-friendly aspects and green building initiatives.</p>
    </section>
  );
};

export default SustainabilityFeatures;